import React, { useState } from 'react';
import { buildCountryDisplay } from '../utils/country';

interface CountryBadgeProps {
  countryName?: string | null;
  countryCode?: string | null;
  className?: string;
  fallback?: React.ReactNode;
}

const CountryBadge: React.FC<CountryBadgeProps> = ({
  countryName,
  countryCode,
  className,
  fallback = '-'
}) => {
  const display = buildCountryDisplay(countryCode, countryName);
  const [imgError, setImgError] = useState(false);

  if (!display) {
    const fallbackClasses = ['country-badge', 'country-badge--empty', className]
      .filter(Boolean)
      .join(' ');

    return (
      <span className={fallbackClasses} aria-hidden="true">
        {fallback}
      </span>
    );
  }

  const classes = ['country-badge', className].filter(Boolean).join(' ');
  const hasFlag = Boolean(display.flag);
  const iso2 = display.iso2?.toLowerCase();
  const cdnBase = 'https://flagicons.lipis.dev';
  const flagImgSrc = !imgError && iso2 ? `${cdnBase}/flags/4x3/${iso2}.svg` : undefined;

  return (
    <span
      className={classes}
      title={display.title}
      aria-label={display.ariaLabel}
    >
      {flagImgSrc ? (
        <img
          className="country-badge__flag"
          src={flagImgSrc}
          alt=""
          loading="lazy"
          width={24}
          height={18}
          onError={() => setImgError(true)}
        />
      ) : hasFlag ? (
        <span className="country-badge__flag country-badge__flag--emoji" role="img" aria-hidden="true">
          {display.flag}
        </span>
      ) : (
        <span className="country-badge__code">{display.iso3}</span>
      )}
    </span>
  );
};

export default CountryBadge;
